"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BarNavPosition;
(function (BarNavPosition) {
    BarNavPosition[BarNavPosition["Left"] = 0] = "Left";
    BarNavPosition[BarNavPosition["Right"] = 1] = "Right";
})(BarNavPosition = exports.BarNavPosition || (exports.BarNavPosition = {}));
//# sourceMappingURL=BarNavPosition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/BarNavPosition.js
// module id = 200
// module chunks = 1